import React, { useState } from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { FaBars } from "react-icons/fa6";

export const Header = () => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      wp {
        acfOptionsHeader {
          siteHeader {
            siteLogo {
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            topMenu {
              label
              link {
                ... on WpPage {
                  uri
                }
              }
              icon
            }
          }
        }
        acfOptionsMainMenu {
          mainMenu {
            menu {
              root {
                label
                link {
                  ... on WpPage {
                    uri
                  }
                }
                internalLinkOrUrl
                url
              }
              subMenu {
                label
                link {
                  ... on WpPage {
                    uri
                  }
                }
              }
              megaMenu
              megaMenuCol1 {
                label
                link
              }
              megaMenuCol2 {
                label
                link
              }
            }
          }
        }
      }
    }
  `);
  const image = getImage(
    data.wp.acfOptionsHeader.siteHeader.siteLogo.localFile.childImageSharp
      .gatsbyImageData
  );
  const { topMenu } = data.wp.acfOptionsHeader.siteHeader;
  const { mainMenu } = data.wp.acfOptionsMainMenu;
  const [mobileMenu, setMobileMenu] = useState(false);
  return (
    <header className="bg-white py-8 font-futuraMd">
      <div className="container relative mx-auto">
        <div className="flex items-center justify-between">
          <div className="px-4">
            <Link to="/">
              <GatsbyImage
                image={image}
                alt={data.wp.acfOptionsHeader.siteHeader.siteLogo.altText}
              />
            </Link>
          </div>
          <div className="px-4">
            <button
              className="block border-0 bg-transparent p-4 text-darkblack lg:hidden"
              onClick={(e) => {
                e.preventDefault();
                setMobileMenu((prevState) => !prevState);
              }}
            >
              <FaBars />
            </button>
            <div
              className={`absolute left-0 top-full z-30 w-screen bg-white shadow-submenushadow transition-all duration-500 lg:relative lg:left-auto lg:w-auto lg:shadow-transparent ${
                mobileMenu
                  ? "visible opacity-100 lg:visible lg:opacity-100"
                  : "invisible opacity-0 lg:visible lg:opacity-100"
              }`}
            >
              {topMenu?.length > 1 && (
                <div className="relative top-0 right-0 mb-0 flex flex-col items-center justify-end lg:absolute lg:-top-2/4 lg:flex-row">
                  {topMenu.map((topMenuItem, index) => {
                    return (
                      <Link
                        key={index}
                        to={topMenuItem.link.uri}
                        className="ml-2 mb-2 flex items-center text-xl text-secondary no-underline lg:mb-0"
                      >
                        <span>{topMenuItem.label}</span>{" "}
                        <span
                          dangerouslySetInnerHTML={{ __html: topMenuItem.icon }}
                          style={{ width: "24px" }}
                        ></span>
                      </Link>
                    );
                  })}
                </div>
              )}
              <div className="flex flex-col items-center justify-end lg:flex-row">
                <ul className="flex-col items-center justify-end lg:flex lg:flex-row">
                  {(mainMenu.menu || []).map((mainMenuItem, index) => {
                    return (
                      <li
                        key={index}
                        className="group relative items-center lg:flex"
                      >
                        {mainMenuItem.root.internalLinkOrUrl === true ? (
                          <Link
                            to={mainMenuItem.root.link.uri}
                            className="mb-2 text-base text-primary no-underline lg:mx-4 lg:mb-0 2xl:text-xl"
                          >
                            {mainMenuItem.root.label}
                          </Link>
                        ) : (
                          <a
                            href={
                              mainMenuItem.root.url === ""
                                ? "#"
                                : mainMenuItem.root.url || "/"
                            }
                            className="mb-2 text-base text-primary no-underline lg:mx-4 lg:mb-0 2xl:text-xl"
                          >
                            {mainMenuItem.root.label}
                          </a>
                        )}
                        {(mainMenuItem.megaMenu === true ||
                          mainMenuItem?.subMenu?.length) > 0 && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="12"
                            viewBox="0 0 16 12"
                            fill="none"
                            className="hidden transition-all duration-500 lg:inline-block lg:group-hover:rotate-180"
                          >
                            <path
                              d="M6.82519 10.5201C7.42573 11.2766 8.57427 11.2766 9.17482 10.5201L15.5951 2.43263C16.3755 1.4496 15.6754 0 14.4203 0H1.5797C0.324562 0 -0.375507 1.4496 0.404884 2.43264L6.82519 10.5201Z"
                              fill="#012D61"
                            />
                          </svg>
                        )}
                        {mainMenuItem.megaMenu === true ? (
                          <div className="relative block flex-col items-center justify-end whitespace-nowrap p-2 lg:absolute lg:top-full lg:hidden lg:flex-row lg:bg-submenugrey lg:p-4 lg:text-center lg:shadow-submenushadow lg:group-hover:flex">
                            <ul className="lg:border-r lg:border-solid lg:border-submenutextcolor lg:px-4">
                              {mainMenuItem.megaMenuCol1.map(
                                (subMenuItem, subMenuIndex) => (
                                  <li key={subMenuIndex}>
                                    <Link
                                      to={subMenuItem.link || "/"}
                                      className="mb-2 block text-base text-submenutextcolor no-underline hover:text-secondary lg:mb-0 lg:p-2 2xl:text-xl"
                                    >
                                      {subMenuItem.label}
                                    </Link>
                                  </li>
                                )
                              )}
                            </ul>
                            <ul className="lg:px-4">
                              {mainMenuItem.megaMenuCol2.map(
                                (subMenuItem, subMenuIndex) => (
                                  <li key={subMenuIndex}>
                                    <Link
                                      to={subMenuItem.link || "/"}
                                      className="mb-2 block text-base text-submenutextcolor no-underline hover:text-secondary lg:mb-0 lg:p-2 2xl:text-xl"
                                    >
                                      {subMenuItem.label}
                                    </Link>
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        ) : (
                          mainMenuItem?.subMenu?.length > 0 && (
                            <ul className="relative top-full block whitespace-nowrap p-2 lg:absolute lg:hidden lg:bg-submenugrey lg:p-4 lg:text-center lg:shadow-submenushadow lg:group-hover:block">
                              {mainMenuItem.subMenu.map(
                                (subMenuItem, subMenuIndex) => (
                                  <li key={subMenuIndex}>
                                    {subMenuItem.link?.uri ? (
                                      <Link
                                        to={subMenuItem.link.uri || "/"}
                                        className="mb-2 block text-base text-submenutextcolor no-underline hover:text-secondary lg:mb-0 lg:p-2 2xl:text-xl"
                                      >
                                        {subMenuItem.label}
                                      </Link>
                                    ) : (
                                      <a
                                        href={subMenuItem.link || "/"}
                                        className="mb-2 block text-base text-submenutextcolor no-underline hover:text-secondary lg:mb-0 lg:p-2 2xl:text-xl"
                                      >
                                        {subMenuItem.label}
                                      </a>
                                    )}
                                  </li>
                                )
                              )}
                            </ul>
                          )
                        )}
                      </li>
                    );
                  })}
                </ul>
                <a
                  href="tel:+91 96771 88888"
                  className="mx-4 mb-2 rounded-full bg-primary py-3 px-6 text-base text-white no-underline lg:mb-0 2xl:text-2xl"
                >
                  <svg
                    width="15"
                    height="14"
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ display: "inline-block" }}
                  >
                    <path
                      d="M4.8268 7.08225C5.42685 8.20491 6.42886 9.11038 7.66956 9.65113C7.76108 9.69039 7.8623 9.70739 7.96327 9.70044C8.06424 9.69349 8.16147 9.66284 8.2454 9.61151L10.0677 8.50867C10.1482 8.4592 10.2412 8.42902 10.3381 8.42093C10.435 8.41285 10.5325 8.42713 10.6217 8.46245L14.033 9.78981C14.1496 9.83378 14.247 9.91124 14.3102 10.0103C14.3734 10.1093 14.3989 10.2245 14.3828 10.3379C14.2747 11.1025 13.8628 11.8051 13.2242 12.3144C12.5856 12.8237 11.764 13.1048 10.9132 13.1049C8.28407 13.1049 5.76261 12.1587 3.90352 10.4744C2.04443 8.7901 1 6.5057 1 4.12374C1.00019 3.35294 1.31038 2.60862 1.87253 2.03004C2.43467 1.45146 3.21026 1.07828 4.05415 0.980326C4.1794 0.96575 4.30647 0.988881 4.41579 1.04616C4.52511 1.10344 4.61062 1.19168 4.65914 1.29731L6.12426 4.3945C6.16236 4.47397 6.1783 4.56072 6.17067 4.64709C6.16305 4.73346 6.13209 4.81681 6.08053 4.88978L4.86324 6.56715C4.80905 6.64302 4.77724 6.73021 4.77086 6.82039C4.76448 6.91058 4.78374 7.00074 4.8268 7.08225V7.08225Z"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>{" "}
                  <span>+91 96771 88888</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
